module.exports = __webpack_public_path__ + "img/Qrespi-Icon-semi-transparant.b00192ac.svg";